import {
  VULNERABLE,
  HIT_POINT,
} from '../../character/content/templates';

export default function Stress() {
  return (
    <>
      <p><strong>Stress</strong> represents how much mental, physical, and emotional strain a character can endure. All classes start with 6 Stress slots. You'll be able to increase the number of Stress slots you have available as you level up, to a maximum of 12. Some special abilities or effects require the character activating them to mark Stress, and the GM can require a PC to mark Stress as a GM move or to represent the cost, complication, or consequence of an action roll.</p>
      <p>When a character marks their last Stress, they become {VULNERABLE} until they clear at least 1 Stress.</p>
      <p>When a character must mark 1 or more Stress but can't, they mark 1 {HIT_POINT} instead. A character can't use a move that requires them to mark Stress if all of their Stress is marked.</p>
      <p>PCs can clear Stress by making downtime moves (see: Downtime). A PC's maximum Stress is determined by their class, but they can increase it through advancements, abilities, and other effects.</p>
    </>
  );
}
